import { computed } from 'mobx';
import { ViewController } from '@estee/elc-service';
import { LoadLoyaltyInfoUseCase } from '~use-cases/LoadLoyaltyInfoUseCase';

class LoyaltyEarnPointsController extends ViewController {
    public loaded = async () => {
        this.isLoading = true;
        await new LoadLoyaltyInfoUseCase().execute();
        this.isLoading = false;
    };

    @computed public get data() {
        return {
            isLoading: this.isLoading
        };
    }
}

export default LoyaltyEarnPointsController;
